import { SelectedTabEnum } from "../../enum/app-settings/AppSettingsEnum";

export const appSettingsTabsYQB = [
  {
    id: SelectedTabEnum.DATE_TIME,
    label: "Date & Time",
  },
  {
    id: SelectedTabEnum.HEALTH_OF_OPERATIONS,
    label: "Health of operation",
  },
  {
    id: SelectedTabEnum.KPI_CONFIGURATION,
    label: "KPI Configuration",
  },
];

export const appSettingsTabsOther = [
  {
    id: SelectedTabEnum.PASSENGER_FLOW,
    label: "Passenger flow",
  },
];
